/* eslint-disable jsx-a11y/anchor-is-valid */
import { globalVariables } from "helper/globalVariables";
import { Button } from "shared/Components/button";

export const JudgeListCard = ({ judge, onViewMoreClick }) => {
  return (
    <div class="bg-white p-4 flex flex-col flex-1 result-card-box">
      <div className="flex flex-col">
        <span class="text-lg font-semibold text-gray-900">
          {globalVariables.judgeName}: {judge.name}
        </span>
        <span class="text-sm text-gray-600 font-semibold">
          {globalVariables.phoneNumber}: {judge.phoneNumber}
        </span>
        <span class="text-sm text-gray-600 font-semibold">
          {globalVariables.email}: {judge.email}
        </span>
      </div>
      <div className="pt-8 flex justify-end">
        <Button
          label={globalVariables.viewMore}
          width="w-32"
          onClick={onViewMoreClick}
        />
      </div>
    </div>
  );
};
